import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ObjectLookupComponent } from './object-lookup.component';
import { CountryService } from 'app/server/services/country/country.service';

@Component({
  selector: 'app-country-object-lookup',
  templateUrl: './country-object-lookup.component.html',
  styleUrls: ['./object-lookup.component.scss']
})
export class CountryObjectLookupComponent extends ObjectLookupComponent {
  constructor(private countryService: CountryService) {
    super();
  }

  protected loadObjectByIdFromService(id: number) {
    // Ensure countries are loaded and find the matching country
    this.countryService.getCountries();
    this.countryService.countries$.pipe(take(1), catchError(() => of([]))).subscribe((list: any[]) => {
      this.isLoadingObject = false;
      const result = (list || []).find(c => this.getObjectId(c) === id);
      if (result) {
        this.selectedObject = result;
        this.searchTerm = this.getObjectName(result);
        this.isSearching = false;
      } else {
        this.selectedObject = null;
        this.searchResults = [];
        this.searchTerm = '';
        this.isSearching = true;
      }
    });
  }

  public getObjectType(): string {
    return 'Country';
  }

  protected searchObjects(searchText: string): Observable<any[]> {
    if (!searchText) {
      return of([]);
    }

    // ensure list is requested
    this.countryService.getCountries();
    return this.countryService.countries$.pipe(
      map(list => (list || []).filter(c => this.getObjectName(c).toLowerCase().includes(searchText.toLowerCase()))),
      catchError(() => of([]))
    );
  }

  public getObjectName(item: any): string {
    return item?.Name || item?.CountryName || item?.Country || '';
  }

  public getObjectId(item: any): number | null {
    return item?.CountryID ?? item?.ID ?? null;
  }
}
